import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

const activities = [
  { icon: 'ri-palette-line', label: 'Design graphique' },
  { icon: 'ri-eye-line', label: 'Conception visuelle' },
  { icon: 'ri-layout-line', label: 'Création de supports de communication' },
];

export default function About() {
  return (
    <main style={{ fontFamily: "'DM Sans', sans-serif" }}>
      <Navbar />

      {/* ── Hero ── */}
      <section className="bg-white pt-32 pb-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <span className="text-xs font-medium tracking-widest text-[#6B6B6B] uppercase">Studio</span>
          <h1 className="text-5xl lg:text-7xl font-bold text-[#0A0A0A] mt-3 leading-tight">
            À propos
          </h1>
          <div className="mt-4 w-16 h-0.5 bg-[#0A0A0A]" />
        </div>
      </section>

      {/* ── Main Content ── */}
      <section className="bg-white py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-20 items-start">

            {/* Text */}
            <div className="lg:col-span-3">
              <p className="text-xl lg:text-2xl text-[#0A0A0A] leading-relaxed mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
                HASPICA est une activité indépendante de design basée à Bordeaux.
              </p>
              <p className="text-base text-[#6B6B6B] leading-relaxed mb-6">
                Le studio est dirigé par <strong className="text-[#0A0A0A]">Patrik Haspica</strong>, designer indépendant proposant des solutions visuelles pour différents types de projets. Chaque mission est abordée avec rigueur et créativité, afin de livrer des résultats à la hauteur des attentes.
              </p>
              <p className="text-base text-[#6B6B6B] leading-relaxed mb-10">
                L'objectif est de proposer des solutions simples, fonctionnelles et adaptées à chaque client — qu'il s'agisse d'une identité visuelle, d'un support de communication ou d'un concept créatif sur mesure.
              </p>

              {/* Activities */}
              <h2 className="text-xs font-semibold tracking-widest text-[#6B6B6B] uppercase mb-5">Domaines d'activité</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
                {activities.map((act) => (
                  <div
                    key={act.label}
                    className="flex flex-col items-start gap-3 p-5 bg-[#F7F6F4] rounded-lg"
                  >
                    <div className="w-8 h-8 flex items-center justify-center">
                      <i className={`${act.icon} text-xl text-[#0A0A0A]`} />
                    </div>
                    <span className="text-sm font-medium text-[#0A0A0A] leading-snug">{act.label}</span>
                  </div>
                ))}
              </div>

              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-7 py-3.5 bg-[#0A0A0A] text-white text-sm font-medium rounded-md whitespace-nowrap cursor-pointer hover:bg-[#2A2A2A] transition-colors duration-200"
              >
                Travailler ensemble
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm" />
                </div>
              </Link>
            </div>

            {/* Image + Info Card */}
            <div className="lg:col-span-2 flex flex-col gap-6">
              <div className="w-full h-80 lg:h-96 rounded-lg overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/e85ec54a71d2cf63600366972c08849d.jpg"
                  alt="Patrik Haspica – Designer indépendant à Bordeaux"
                  title="Patrik Haspica, fondateur HASPICA design Bordeaux"
                  className="w-full h-full object-cover object-top"
                />
              </div>

              {/* Info Card */}
              <div className="bg-[#F7F6F4] rounded-lg p-6">
                <h3 className="text-xs font-semibold tracking-widest text-[#6B6B6B] uppercase mb-4">Informations</h3>
                <dl className="space-y-2 text-sm" style={{ fontFamily: "'DM Sans', monospace" }}>
                  <div className="flex justify-between gap-4">
                    <dt className="text-[#6B6B6B]">Dirigeant</dt>
                    <dd className="text-[#0A0A0A] font-medium text-right">Patrik Haspica</dd>
                  </div>
                  <div className="flex justify-between gap-4">
                    <dt className="text-[#6B6B6B]">Statut</dt>
                    <dd className="text-[#0A0A0A] font-medium text-right">Entrepreneur individuel</dd>
                  </div>
                  <div className="flex justify-between gap-4">
                    <dt className="text-[#6B6B6B]">SIRET</dt>
                    <dd className="text-[#0A0A0A] font-medium text-right">102 262 441 00011</dd>
                  </div>
                  <div className="flex justify-between gap-4">
                    <dt className="text-[#6B6B6B]">NAF</dt>
                    <dd className="text-[#0A0A0A] font-medium text-right">74.10Z</dd>
                  </div>
                  <div className="flex justify-between gap-4">
                    <dt className="text-[#6B6B6B]">Ville</dt>
                    <dd className="text-[#0A0A0A] font-medium text-right">Bordeaux, France</dd>
                  </div>
                </dl>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ── Manifeste ── */}
      <section className="bg-[#F7F6F4] py-20 text-center">
        <div className="max-w-2xl mx-auto px-6 lg:px-12">
          <i className="ri-double-quotes-l text-5xl text-gray-300 block mb-4" />
          <blockquote
            className="text-xl lg:text-2xl leading-relaxed text-[#2A2A2A]"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Des solutions simples, fonctionnelles et adaptées à chaque client. La clarté visuelle au service de vos projets.
          </blockquote>
          <p className="mt-6 text-sm text-[#6B6B6B]">— Patrik Haspica, HASPICA Studio</p>
        </div>
      </section>

      <Footer />
    </main>
  );
}
